export const LangEn = {
    name:'en',
    data:{
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "name":'Ceci est un test',
        "pdf_view":{
            "not_found":"This document cannot be found. It may not have been uploaded, or it has been deleted.",
            "error":"The document could not be loaded. Please try again in a few moments.",
            "retry":"Try again"
        },
        "residencePermit":{
            "title":"Residence permit",
            "valid_until":"Valid until {date}",
            "expires_on":"Expires on {date}",
            "expired_on":"Expired on {date}",
            "end_unknown":"End date not provided",
            "document_types":{
                "new_permit":"New residence permit",
                "receipt":"Renewal receipt",
                "anef_extension":"Application extension certificate (ANEF)"
            },
            "document_status":{
                "pending":"Under review",
                "validated_until":"Approved until {date}",
                "validated":"Approved",
                "refused_with_reason":"Refused: {reason}",
                "refused":"Refused"
            },
            "add_extension":"Add my extension",
            "banner_expiring_title":"Your residence permit expires soon",
            "banner_expiring_text":"Add its extension to keep receiving missions.",
            "banner_expired_title":"Residence permit expired",
            "banner_expired_text":"Add its extension: no mission can be assigned to you in the meantime.",
            "extension_modal":{
                "choice_title":"Residence permit extension",
                "choice_subtitle":"Which document did you receive?",
                "choice_consent":"By selecting a document, you allow our partners to verify your identity and accept our privacy policy.",
                "options":{
                    "new_permit":{
                        "title":"New residence permit",
                        "subtitle":"Renewed residence card or visa, front and back",
                        "import_button":"Upload the residence permit"
                    },
                    "receipt":{
                        "title":"Renewal receipt",
                        "subtitle":"Issued by the prefecture while your application is being reviewed",
                        "import_button":"Upload the receipt"
                    },
                    "anef_extension":{
                        "title":"Application extension certificate",
                        "subtitle":"Downloaded from the ANEF website",
                        "import_button":"Upload the certificate"
                    }
                },
                "conditions_intro":"Make sure the document meets these conditions:",
                "conditions":{
                    "readable_title":"Readable",
                    "readable_text":"No blur or glare: every detail can be read.",
                    "whole_title":"The whole document is visible",
                    "whole_text":"All four corners show, nothing is cut off or hidden.",
                    "end_date_title":"End date readable",
                    "end_date_text":"The date until which it is valid appears."
                },
                "file_front":"Front",
                "file_back":"Back",
                "file_single":"Document",
                "back":"Back",
                "analysing":"Sending the document…",
                "success":"Document sent: it is being checked.",
                "errors":{
                    "VISA_COMPLEMENTARY_PENDING":"A document is already under review: wait for its outcome before adding another one.",
                    "RESIDENCE_PERMIT_MISSING":"Add your residence permit first, before its extension.",
                    "VISA_COMPLEMENTARY_FILE_MISSING":"A file is missing: upload each requested side.",
                    "default":"An error occurred. Please try again in a few moments."
                }
            }
        },
        "licences":{
            "label_with_category":"{licence} · category {category}",
            "add_modal":{
                "title":"Add a licence",
                "subtitle":"Add your licences to access the missions that require them.",
                "search_placeholder":"Search for a licence",
                "catalogue_loading":"Loading licences…",
                "catalogue_error":"The list of licences could not be loaded. Please try again in a few moments.",
                "no_result":"No licence matches your search.",
                "import_button":"Upload my licence",
                "cancel":"Cancel",
                "back":"Back",
                "photo_title":"Licence check",
                "photo_intro":"Take a photo of your licence or upload it: its end of validity date must be readable.",
                "file_label":"Upload",
                "take_photo":"Take a photo",
                "import_file":"Upload a file",
                "validate_photo":"Use this photo",
                "retake_photo":"Retake the photo",
                "conditions_title":"Check your photo",
                "conditions_intro":"Before going on, make sure it meets these conditions.",
                "conditions":{
                    "readable_title":"Readable",
                    "readable_text":"No blur or glare: every detail can be read.",
                    "whole_title":"The whole document is visible",
                    "whole_text":"All four corners show, nothing is cut off or hidden.",
                    "end_date_title":"End of validity date readable",
                    "end_date_text":"We read it on your card to remind you before it expires."
                },
                "confirm":"Yes, all good",
                "sending":"Sending the licence…",
                "success":"Licence sent: it is being checked.",
                "errors":{
                    "LICENCE_NOT_IN_CATALOGUE":"This licence is not in the list. Please choose another one.",
                    "default":"An error occurred. Please try again in a few moments."
                }
            },
            "expiry_banner":{
                "expiring_title":"Your {label} expires on {date}",
                "expired_title":"Your {label} expired on {date}",
                "text":"Renew it to keep the missions that require it"
            },
            "types":{
                "caces":"CACES",
                "permit":"licence"
            },
            "list":{
                "title":"My licences",
                "add_button":"Add a licence",
                "empty":"You have not added any licence yet.",
                "delete":"Delete",
                "state":{
                    "pending":"Being checked",
                    "refused":"Refused: {reason}",
                    "refused_no_reason":"Refused",
                    "accepted":"Accepted",
                    "valid":"Valid until {date}",
                    "expiring":"Expires soon: on {date}",
                    "expired":"Expired on {date}"
                }
            },
            "detail_modal":{
                "pending_title":"Your {type} is being checked",
                "delay_title":"Checking time",
                "delay_text":"Up to 48 business hours",
                "end_date_title":"End of validity date",
                "end_date_text":"Read on your card by our team",
                "view_document":"View the document",
                "close":"Close",
                "state_text":{
                    "valid":"Checked by our team.",
                    "accepted":"Checked by our team.",
                    "expiring":"Checked by our team. It expires soon: renew it to keep the missions that require it.",
                    "expired":"Checked by our team. It has expired: renew it to keep the missions that require it."
                },
                "valid_until_title":"Valid until",
                "valid_until_text":"{date}, date read on your card",
                "document_title":"Document",
                "document_verified_on":"Checked on {date}",
                "not_deletable_title":"Cannot be deleted",
                "not_deletable_text":"Your new {type} will replace it once checked",
                "add_new":"Add my new {type}",
                "refused_title":"Document refused",
                "refusal_reason_title":"Reason for refusal:",
                "import_new":"Upload a new document"
            },
            "delete_modal":{
                "title":"Delete the {type}",
                "text":"Are you sure you want to delete “{label}”?",
                "not_verified":"It has not been checked yet.",
                "confirm":"Delete",
                "cancel":"Cancel",
                "success":"The licence has been deleted.",
                "errors":{
                    "LICENCE_NOT_DELETABLE":"This licence has been checked in the meantime: it can no longer be deleted.",
                    "LICENCE_NOT_FOUND":"This licence has already been deleted.",
                    "default":"An error occurred. Please try again in a few moments."
                }
            }
        },
        "mission":{
            "tasks_title":"Tasks of the ",
            "tasks_title_elided":"Tasks of the ",
            "tool_provider_company":"Provided by the company",
            "tool_provider_temp_worker":"Bring your own",
            "dress_code_title":"Dress code"
        },
        "signature":{
            "loading_title":"Preparing your contract",
            "loading_text":"It will open in a moment."
        },
        "endOfMissionDocuments":{
            "title":"End-of-mission documents",
            "subtitle":"Work certificates, France Travail certificates",
            "all_missions":"All your missions",
            "types":{
                "work_certificate":"Work certificate",
                "france_travail_certificate":"France Travail certificate"
            },
            "received_on":{
                "work_certificate":"Received on {date}",
                "france_travail_certificate":"Received on {date}"
            },
            "pending_tag":"In preparation",
            "pending_hint":"With your {month} payslip",
            "pending_hint_elided":"With your {month} payslip",
            "pending_modal_title":"Your France Travail certificate arrives in early {month}",
            "pending_modal_text":"It is issued with your {month} payslip.",
            "pending_modal_text_elided":"It is issued with your {month} payslip.",
            "pending_modal_close":"Got it",
            "months":["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        },
        map : new Map()
    }
}